var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9.7H3.6c.2 0 .4-.1.6-.1.3 0 .5 0 .7.1z",
    opacity: 0.553,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#69444c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8.7s0 .1.1.1.1 0 .2.1c-.1.1 0 .1.1.1v.1c.1-.1.1-.1.2-.1V.9c.2.1.4.2.6.4 0 .2.1.2.3.2 0 0 .1 0 .1.1v.1c.1 0 .1.1.2.1 0 .1 0 .1.1.1 0 0 0 .1.1.1 0 0 .1 0 .1.1s.1.1.1.1c-.1 0-.1 0 0 .1 0 .1-.1.1-.1.1.1 0 .1-.1 0-.1s-.1 0-.1.1h-.2v.1h-.1v.1c-.1 0-.1.1 0 .2 0 0 0 .1-.1.1.1 0 .1.1.1.1 0 .1-.1.1-.1.2h-.1.1c-.1 0-.1 0-.2-.1-.1-.2-.3-.3-.4-.5 0-.1-.1-.1-.1-.1s-.1 0-.1-.1-.1-.1-.1-.1 0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1-.2.2-.4.1-.7 0-.1 0-.1-.1-.2-.1-.6-.1-1.1-.1-1.7 0-.1 0-.2 0-.3-.1 0 0 0-.1-.1-.1-.2 0-.3-.1-.3-.2v-.4s0-.1.1-.1l.1-.1c0-.1.1-.1.2-.1s.1 0 .2-.1c.3-.1.6-.1 1-.1s.8 0 1.3.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3fc0f7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 .7c.3.1.7.2 1 .3-.4-.1-.7-.2-1-.3z",
    opacity: 0.729,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#673e45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5.7c-.1 0-.1.1-.2.1 0-.1.1-.1.2-.1z",
    opacity: 0.812,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#456977"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2.7c-.2.1-.4.2-.5.2.1-.1.3-.1.5-.2z",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#7c4751"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9.7s.1 0 0 0c.4.1.7.2 1 .3h.2c.2.1.3.1.4.2 0 .1.1.1.1.2.1 0 .1 0 .1.1h.1c.2.1.4.2.5.4l.4.4v.2c-.1 0-.1 0-.1-.1v-.1.1c-.1 0-.1-.1 0-.1-.1-.1-.1-.1-.1 0-.1 0-.1-.1-.1-.1h-.1v-.1c-.2-.2-.3-.3-.4-.3 0-.1 0-.1 0 0 0 0 0-.1-.1-.1 0 0-.1.1-.1 0-.1-.1-.2-.2-.4-.2v.2c-.1 0-.1.1-.1.1h.1c.1-.1.1-.1.1 0 .1.1 0 .1-.1.1 0 .1 0 .2.1.2h-.1s0 .1-.1.1c.2.1.1.2 0 .1h-.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1-.1.1-.1 0-.3 0 .1 0 .1 0 0-.1-.1.1-.2.1-.2.1-.1-.1-.2-.1-.3-.1h-.1H4.1c-.2 0-.4 0-.5.1h-.5v.1c-.1 0-.1 0-.2.1-.1 0-.1.1-.2.1v-.1l.1-.1V2c0-.1 0-.2-.1-.2 0 .1 0 .1-.1 0 0-.1 0-.2-.1-.3-.1 0-.1 0-.1-.1h-.2c0 .1-.1.1-.1.2v-.1H2c-.1 0-.2.1-.3.2v-.1l.1-.1s.1 0 .1-.1c0 0 .1 0 .1-.1h.1s.1 0 .1-.1c.1 0 .2 0 .3-.2.1 0 .2 0 .3-.1.2 0 .3-.1.5-.1.1-.1.3-.1.5-.1.2-.1.7-.1 1.1 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f1647f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8.7c.2.1.4.2.7.3v.1c-.1 0-.2 0-.2.1v-.1C12.1 1 12 1 12 1s-.1-.1-.2-.1V.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43aedb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1.9S9 1 8.9 1c.1-.1.1-.1.2-.1z",
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#416574"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7.9c-.1.1-.2.1-.3.1.1-.1.2-.1.3-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#aa5363"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 1c.1-.1.2 0 .2 0h-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#904953"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 1c-.1.1-.2.2-.3.2.1-.1.2-.2.3-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b05566"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 1.2c-.1 0 0 0 0 0z",
    opacity: 0.706,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6f454d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.3c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0z",
    opacity: 0.647,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#623f46"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 1.1v.4c-.1-.1-.1-.3 0-.4z",
    opacity: 0.788,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#456c7b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 1.3c0 .1-.1.1 0 0-.1 0-.1 0 0 0z",
    opacity: 0.682,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6d444b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.3c.1.1.2.1.3.2h-.1c0-.1-.1-.1-.1-.1s0-.1-.1-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ab5261"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 2.3s0-.1 0 0c-.2 0-.3 0-.4.1 0 .1 0 .1.1.1h-.2v.1h-.1c0 .1-.1.1-.2.2.1 0 .1 0 .1.1h-.1c0 .1-.1.1-.2.1 0 0 0 .1 0 0v.1c-.2 0-.2 0-.1.1h-.1v.1c.1.2 0 .3-.1.4 0 0-.1.1-.1.2s-.1.3-.1.5V5.2c0 .1 0 .2.1.3 0 .1 0 .1.1.2 0 .1.1.3.1.4v.2c0 .1-.1.2-.2.2s-.1 0-.2.1c-.1 0-.2 0-.3-.1 0-.1-.1-.1-.1-.1-.3 0-.4-.2-.5-.4C0 5.4 0 4.8 0 4.2c0-.1 0-.2.1-.3.1-.2.1-.3.2-.5.1-.1.1-.2.1-.3 0 0 .1 0 .1-.1 0 .1 0 .1.1 0v-.1c.1-.1.2-.2.2-.4 0 0 .1 0 .1-.1.1 0 .1-.1.1-.1.1-.3.3-.5.6-.8h.1v.1c.1-.1.2-.2.3-.2h.1v.1c.1 0 .1-.1.2-.1h.2c0 .1.1.1.1.1 0 .1 0 .2.1.3h.1c0 .1 0 .2.1.2-.1 0-.1 0 0 0-.1 0-.1.1-.1.1-.1.1-.1.1-.1.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f1617e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 1.4c.1 0 .2.1.3.2-.2 0-.3-.1-.3-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#469bc1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 1.4l-.1.1h-.1c.1-.1.1-.1.2-.1z",
    opacity: 0.812,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#854a56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 2.3c.1.1.2.1.2.2.2.1.3.3.5.5 0 .1.1.1.1.2.2.2.4.5.7.7h.1c.1.1.3.2.4.4 0 .1.1.1.1.2h.1L12.4 7h-.1L11 5.7c-.1 0-.1 0 0 .1.3.3.6.5.8.8v.2c.1 0 .1 0 0 0 0 0 0-.1.1-.1.1.1.1.2.2.3v.2c.1.1.2.1.2 0v.1l-.1.1c.1.2.2.4.4.6h.3s.1 0 .1-.1v.3s.1 0 .1-.1C13 8.1 13 8 13 8c0 .1 0 .1.1.2 0 .1 0 .1-.1.2-.1.2-.3.3-.6.2-.2-.1-.3-.2-.4-.4 0-.1-.1-.1-.1-.1-.1-.1-.2-.3-.4-.4L10 6.2l-.3-.3-.6-.6c-.2-.1-.4-.3-.5-.5L7.4 3.6c-.3-.2-.5-.4-.7-.6-.1-.2-.3-.4-.5-.5 0 0 0-.1-.1-.1.2.1.2.1 0-.1.1 0 .1-.1.1-.1h.1v-.3c.1 0 .2 0 .1-.1 0-.1 0-.1-.1 0h-.1c-.1-.1 0-.1.1-.2v-.2c.1 0 .3.1.4.2h.1c0 .1 0 .1.1.1 0-.1 0-.1 0 0 .1.1.2.2.2.3v.1h.1c0 .1 0 .1.1.1 0-.1 0-.1.1 0-.1.1-.1.1 0 .1v-.1c.2 0 .2.1.3.1-.1.1-.1.2 0 .2 0-.1-.1-.2 0-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ee5f7d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 1.5l-.8.8c.2-.3.5-.6.8-.8z",
    opacity: 0.671,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#77454e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 1.6c.1.1.2.1.2.2 0 0-.1 0-.2-.2.1.1 0 .1 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#458aa8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 1.8c0 .1 0 0 0 0z",
    opacity: 0.341,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#394d55"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 1.9H4.9h-.8z",
    opacity: 0.021,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#211b1b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 1.9h-.5c.2 0 .4-.1.5 0z",
    opacity: 0.412,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5c3d41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.9c.1 0 .2 0 .2.1 0 0-.1-.1-.2-.1z",
    opacity: 0.612,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5e3d42"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 1.9l.6.6-.2-.2-.4-.4z",
    opacity: 0.588,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#462f32"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 1.9c.1 0 .1 0 .2.1-.1 0-.1 0-.2-.1z",
    opacity: 0.824,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#456977"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 1.9c.1 0 .1.1.1.1-.1 0-.1-.1-.1-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#40758c"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 2c-.1.1-.3.1-.4.2.1-.1.1-.1.2-.1V2h.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#a4505d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2h-.2.2z",
    opacity: 0.424,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#674046"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 2s.1 0 0 0z",
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#354c55"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 2.2c-.2-.1-.4-.1-.5-.2h.2c.1 0 .1 0 0 0 .2 0 .2.1.3.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#c3596c"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 2.1c.1.1.1.1.1.2 0-.1-.1-.1-.1-.2z",
    opacity: 0.894,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f6372"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 2.2s.1 0 0 0c0 .1 0 .1 0 0z",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#54393f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 2.3s.1 0 0 0z",
    opacity: 0.388,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4f373b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 2.3c.1 0 .1 0 0 0 .1 0 0 0 0 0z",
    opacity: 0.529,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#436471"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3c0 .1.1.1.1.1.1.1.2.2.2.3 0 0 0 .1.1.1v.1s0 .1.1.1c.1.1.1.2.2.4 0 .1 0 .2.1.2 0 .1 0 .1.1.2 0 .1 0 .1.1.2.2.7.2 1.4-.1 2 0-.1 0-.2-.1-.2v-.1c0 .1 0 .1.1.1v-.2c.1-.1.1-.3 0-.4v.1s0-.1-.1-.1c0-.1 0-.1-.1-.1-.1-.2-.1-.3-.1-.5-.1 0-.1 0-.1-.1h-.1s.1-.1 0-.1h-.1v.1s-.1-.1 0-.1h-.1c0 .1-.1.1-.1 0-.1 0-.1-.1-.2-.2 0 .1 0 .1-.1 0-.1.1-.1.1-.1.2-.1-.3-.2-.6-.4-1v-.1c0-.1.1-.1.1-.2s-.1-.1-.1-.1 0-.1.1-.1c-.1-.1-.1-.1 0-.2v-.1h.1v-.1h.2c0-.1.1-.1.1-.1v.1c.1 0 .2 0 .2-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3db9f4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3c.1 0 .1.1.1.2 0-.1 0-.1-.1-.2z",
    opacity: 0.918,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#446c7d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.3s.1 0 0 0c0 .1 0 .1 0 0z",
    opacity: 0.659,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5e3d43"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M.8 2.3c0 .1 0 .1-.1.1 0 0 .1 0 .1-.1z",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#794650"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 2.3c.1 0 .1 0 0 0 0 .1 0 .1 0 0z",
    opacity: 0.459,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f5864"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 2.4c.1 0 .1.1.1.1-.1 0-.1-.1-.1-.1z",
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6f434a"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 2.4s.1 0 0 0c0 .1 0 0 0 0z",
    opacity: 0.518,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#405d69"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 2.5c.2.1.4.3.5.5-.2-.2-.4-.3-.5-.5z",
    opacity: 0.824,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#54353a"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5c.1 0 .1 0 .1.1l-.1-.1z",
    opacity: 0.624,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f5d6a"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M.7 2.5z",
    opacity: 0.529,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#644048"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 2.3c-.2.1-.5.3-.7.6 0 0 0-.1-.1-.1.1 0 .1-.1.2-.2h.1v-.1h.2l-.1-.1c.1-.1.3-.1.4-.1 0-.1 0 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#c25567"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 2.6h-.4c.1 0 .1-.1.2-.1.1.1.2.1.2.1z",
    opacity: 0.488,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#68424a"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.3h-.2v-.1h-.1c0-.1-.1-.1-.1 0-.1 0-.1.1-.1.1-.1-.1-.2-.1-.3 0h.1v.2c0 .1.1.1.1.2v.1h-.1l-.1.1V4c-.2-.2-.4-.3-.6-.5-.2-.5-.1-.8.3-1 .2 0 .4 0 .5.1.2.2.4.4.6.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3fbaf1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 2.6c.1 0 .1.1.1.1-.1 0-.1 0-.1-.1z",
    opacity: 0.694,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#364d56"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 2.6c.1 0 .1 0 .2.1 0 .1.1.1.1.2v.2c0 .1 0 .2-.1.3 0 0-.1 0-.1.1v-.1c-.1.1-.2.3-.4.4v.1c-.1 0-.2 0-.2.1 0 0-.1 0-.1.1l-.3.3-.1.1v.2c-.1 0-.2.1-.3.2h-.1c-.1.1-.2.3-.4.4v.1l-.1.1h-.2c-.1 0-.2 0-.2-.1 0 0 0-.1-.1-.1 0 0-.1 0-.1-.1s0-.1-.1-.2v-.3s.1 0 .1-.1c.2-.1.3-.3.4-.4.1 0 .1-.1.2-.2h.2c.3-.2.5-.5.8-.8 0-.1.1-.2.2-.3 0 0 .1-.1.2-.1s.1-.1.2-.1c0-.1.2-.1.3-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f1607e"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M.7 2.5c0 .2 0 .3-.2.4V3c0 .1-.1.1-.1 0 0 0 0 .1-.1.1.1-.2.2-.4.4-.6z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#cb5a70"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 2.6c0 .1-.1.1-.2.1.1 0 .1-.1.2-.1z",
    opacity: 0.859,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#934d5b"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 2.7c.1 0 .1.1.1.2-.1-.1-.1-.1-.1-.2z",
    opacity: 0.859,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#77434d"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 2.7s0 .1 0 0c0 .1 0 .1 0 0z",
    opacity: 0.529,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#446370"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 2.8c-.1 0-.2.1-.2.1 0-.1.1-.1.2-.1z",
    opacity: 0.553,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#56383f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.9l-.4.4v-.1h.1c-.1-.1-.1-.2 0-.2 0 0-.1 0 0-.1.1 0 .1 0 0 0H2c-.1 0 0 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#c35567"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.9z",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3b525b"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 3c.1 0 .1.1.1.2-.1-.1-.1-.2-.1-.2z",
    opacity: 0.824,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#77444c"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 2.9c.1.1.1.3 0 .4 0-.1 0-.2.1-.3-.1 0-.1-.1-.1-.1z",
    opacity: 0.282,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4d353a"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.3c.2.2.5.4.7.7 0 .1.1.1.2.2.2.2.4.4.6.5v.2c-.1-.1-.2-.2-.2-.3-.1.1-.1.1-.2 0h-.1c-.1 0-.1.1-.2.1v.1h-.1V5h-.1c-.1 0-.1 0-.1.1h0c.1.1.1.1.1.2l-.2-.2s0-.1-.1-.1c0-.1-.1-.2-.2-.2 0-.1 0-.1-.1-.1l-.2-.2c0-.1 0-.1 0 0 0-.1-.1-.2-.2-.3v.1c0-.2-.1-.3-.3-.3v-.1c0-.1-.1-.1-.1 0 0 0-.1 0-.1-.1v-.1s.1 0 .1-.1h.1v-.1s-.1-.1-.1-.2v-.2h-.1c.1-.1.2-.1.3 0 0 0 0-.1.1-.1h.2v.1c.2.1.2.1.3.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3dbbf7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.1c.3.2.5.5.7.7h-.1c-.2-.2-.4-.4-.6-.7z",
    opacity: 0.776,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#613a41"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 3.2c.1 0 .1 0 .2.1h-.1.1v.1c-.1 0-.1-.1-.2-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#458aae"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M.4 3.1c0 .1 0 .2-.1.3 0-.2 0-.2.1-.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b15265"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 3.4z",
    opacity: 0.024,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#39272a"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 3.4c0 .1.1.1.1.2-.1-.1-.1-.2-.1-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#406c81"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M.2 3.4c0 .2-.1.3-.2.5.1-.2.2-.4.2-.5z",
    opacity: 0.859,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#76454e"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 3.2c-.2.3-.4.5-.7.8.2-.3.5-.6.7-.8z",
    opacity: 0.765,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#7b454f"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 3.6l1.2 1.2c-.4-.4-.9-.8-1.2-1.2z",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#55363c"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 3.4c-.2.2-.3.4-.5.5v-.1c.2-.1.3-.3.5-.4-.1 0 0 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b95264"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 3.6c0 .1.1.1.1.2-.1-.1-.1-.1-.1-.2z",
    opacity: 0.882,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#446a7e"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 3.7c0 .1 0 .1-.1.2.1-.1.1-.1.1-.2z",
    opacity: 0.435,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5b3e43"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 3.9c-.2.4-.2.9-.2 1.3v-.1-.7c0-.2.1-.4.2-.5z",
    opacity: 0.635,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5f3e43"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 3.9l.2.2c-.1 0-.2-.1-.2-.2z",
    opacity: 0.576,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2f4149"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 4c.1 0 .1 0 0 0z",
    opacity: 0.635,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#38525c"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 3.8c0 .1.1.1.1.2-.1 0-.1-.1-.1-.2z",
    opacity: 0.659,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#456473"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 3.9c.1 0 .1 0 .1.1 0-.1.1-.1.1 0v.1c.2 0 .3.1.3.3v-.1c.1.1.2.1.2.3 0-.1 0-.1 0 0-.2-.2-.4-.4-.5-.6 0 0 0-.1-.1-.1 0 .1-.1 0-.1 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#47aee0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 3.9c-.2.3-.5.5-.7.7v-.2c.1 0 .1 0 .1-.1.1 0 .2-.1.3-.2 0-.1.1-.1.1 0 0-.1.1-.2.2-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ca596b"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 6.1c0 .2-.2.4-.3.6-.2.1-.4.1-.6 0 0 0 0-.1-.1-.1-.2-.2-.3-.4-.2-.6 0-.1.1-.1.1-.2.1-.5.1-.9.1-1.4 0-.1 0-.2.1-.2 0 .1 0 .1.1 0 0 .1.1.1.2.2h.2v0c0 .1 0 .1.1 0v.1h.1c0 .1 0 .1.1.1-.1.2 0 .3.1.5.1 0 .1.1.1.1s0 .1.1.1.1 0 0 0v-.1c.1.1 0 .3 0 .4 0 .1 0 .1 0 0v.2l-.1-.1v.1c-.1.1-.1.2-.1.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3eb4f4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 4.1c0 .1-.1.2-.2.2.1-.1.2-.1.2-.2z",
    opacity: 0.835,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#964f5d"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 4.4h-.5l.1-.1h.2s.1.1.2.1z",
    opacity: 0.729,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#45536f"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 4.3c-.2.1-.3.3-.4.4.1-.2.2-.3.4-.4z",
    opacity: 0.835,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#8f4c59"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 4.4c.1 0 .1.1.2.2 0 0 0 .1.1.1 0 .1 0 .3-.1.4 0 0-.1 0-.1.1-.1 0-.1 0-.1.1-.1 0-.1 0-.1.1 0 0-.1 0-.1.1v-.1s-.1.1-.1 0h-.1.1s-.1 0-.1.1c0 0-.1 0-.1.1 0 0-.1-.1-.1 0v.1H5c-.1 0-.1 0 0-.1h-.2-.1v-.1h-.1-.1v-.1h-.1c-.1 0-.2.2-.3.3v.1H4v.1c-.1 0-.1-.1-.1-.1v-.1l.8-.8c.2-.2.3-.3.4-.5h.6z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4e77f0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 4.3l.3.3h-.1c-.1-.1-.1-.2-.2-.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b35163"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.9c0 .3-.1.5-.5.6-.1 0-.2 0-.3-.1 0 0 0-.1-.1-.1 0-.1 0-.1-.1-.2h.1c0-.1-.1-.1-.1 0v-.2h.1v-.2h.1v-.1c.1 0 .1-.1.2-.1h.1c0 .1.1.1.2 0 .1.2.2.3.3.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3db4f3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 4.6z",
    opacity: 0.482,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#404b64"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 4.4c-.1.2-.2.3-.4.5.1-.2.3-.4.4-.5z",
    opacity: 0.694,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f4e6d"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 4.7s-.1.1 0 0c-.1 0-.1 0 0 0z",
    opacity: 0.553,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#73464e"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 4.8c.1 0 .1 0 .1.1l-.1-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#427793"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 4.9c.1 0 .1.1.2.2l-.2-.2z",
    opacity: 0.612,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#30424b"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 4.9c-.1.2-.3.3-.5.5v-.1c.2-.1.3-.3.5-.4-.1 0 0 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b3505f"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 5.1c.1 0 .1 0 0 0 .1 0 0 0 0 0z",
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#374e59"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 5.1c0 .1 0 .1 0 0-.1.1-.1 0 0 0z",
    opacity: 0.024,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#252933"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 5.1c.1 0 .1.1.1.2-.1-.1-.1-.1-.1-.2z",
    opacity: 0.353,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4a3238"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 5.3l.6.6c-.3-.2-.5-.4-.6-.6z",
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5d3940"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 5.2c-.1.1-.1.2-.2.2v-.1s.1 0 .2-.1c-.1 0-.1 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#414f8e"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 5.3s.1 0 0 0c0 .1 0 0 0 0z",
    opacity: 0.435,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#394d56"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 5.3c.1 0 .1 0 0 0 .1.1 0 .1 0 0z",
    opacity: 0.659,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#7c4854"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.2C0 4.8 0 5.4.2 6c-.1-.3-.2-.6-.2-.9v-.9z",
    opacity: 0.435,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4e363a"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 5.5v.1h-.1c-.1.1-.1.1-.1.2h-.1v.1s-.1 0-.1-.1v.4c-.1.2-.3.3-.5.5h-.1c0 .1-.1.1-.2.1v-.2c-.1 0-.2 0-.3-.1 0 0-.1 0-.1.1h-.4l-.1-.1v-.1l.1-.1c0-.1.1-.1.1-.2.3-.1.4-.2.6-.4 0 0 0 .1.1.1v-.1h.1s-.1-.1 0-.1l.3-.3h.1s-.1.1 0 .1h.2s-.1.1 0 .1H5c-.1 0-.1.1 0 .1s.1 0 0 0h.1v-.1h.1c-.1 0 0 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5571f0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 5.4l-.8.8c0-.1 0-.3-.1-.4.1 0 .1.1.1.1v-.1h.1s0-.1.1-.2h.1v-.1s0-.1.1-.1h-.1.2v.1c.2-.1.3-.1.3-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#526ee2"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3 5.6c0 .1.1.1.1.2-.1-.1-.1-.1-.1-.2z",
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#74444c"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 5.7l-.5.5c.2-.2.3-.4.5-.5z",
    opacity: 0.776,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#414f77"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 5.8c0 .1 0 .1-.1.2 0-.1 0-.2.1-.2z",
    opacity: 0.518,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f5661"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 5.8c.1.2.1.4 0 .6v-.2-.4z",
    opacity: 0.482,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6b4349"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 6.3c.1.1.1.2 0 .4-.1-.2-.2-.2-.3 0v.1h.1-.3c-.3-.1-.6-.1-1-.1v.4c0 .1.1.1.2.1.3.1.7.3 1 .4.6.5.7 1 .4 1.6-.4.3-.8.5-1.2.5-.4 0-.8-.1-1.2-.3l-.1-.1c0-.2.1-.3.2-.5l.1-.1c.3.2.7.3 1 .3.3 0 .5-.1.6-.3 0-.1-.1-.2-.2-.3-.4-.1-.7-.3-1.1-.5-.5-.3-.6-.8-.4-1.4.3-.3.7-.5 1.1-.5.4.1.7.1 1.1.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#254070"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.2l1.5 1.5L10 6.2z",
    opacity: 0.812,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#523439"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 6.4c0 .1 0 .1 0 0 0 .1.1.1.1.1h.3c0-.1 0-.1.1 0 0-.1.1-.1.1-.1.1 0 .2.1.3.1 0 .1 0 .1.1.1s.1 0 .2-.1c0 .1-.1.1-.1.1-.3.3-.3.3-.3.4-.1 0-.1 0-.1.1h-.1v.1l-.1.1h-.1c-.1 0-.1-.1 0-.1-.2-.1-.4-.1-.6-.1-.1 0-.2 0-.4-.1v-.1s0-.1.1-.1c.2 0 .3-.2.5-.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#626aee"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 6.6c.1 0 .1 0 .1.1 0-.1 0-.1-.1-.1z",
    opacity: 0.694,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#613d44"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M.7 6.7c.1 0 .2 0 .3.1-.1-.1-.2-.1-.3-.1z",
    opacity: 0.859,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6c3d44"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 6.6c.1 0 .1 0 0 0 0 .1 0 .1 0 0z",
    opacity: 0.341,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#35464d"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 6.7s-.1.1-.2.1c.1-.1.1-.2.2-.1z",
    opacity: 0.224,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4f363b"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 6.3c.1 0 .1.1.1.2 0 .2-.1.3-.2.4-.1 0-.2-.1-.3-.1h.3-.1v-.1c.1-.2.1-.2.3 0 0-.1 0-.3-.1-.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#314166"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 6.3s0 .1-.1.1c-.2.2-.3.4-.5.5l.6-.6z",
    opacity: 0.541,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3d4364"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 6.7c0 .1-.1.2-.2.3v-.1l.2-.2z",
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#282a3a"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 7c.1 0 .2 0 .3.1.2 0 .4 0 .5.2-.1.1-.1.1 0 .1 0 0-.1 0-.1.1h-.1v.1c0-.1 0-.1 0 0v-.1c-.1 0-.1 0-.1-.1-.1 0-.2-.1-.4-.1h-.1c0 .1-.1.1-.1 0v.1h-.1s0 .1-.1.1v-.1c.1-.1.2-.1.2-.2s.1-.1.1-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6c63e9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 7c0 .1-.1.1-.1.2 0-.1.1-.2.1-.2z",
    opacity: 0.871,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5356a2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 6.9c-.2.2-.3.4-.5.5h.1l.1-.1v-.1h.1c0-.2 0-.2.1-.2 0-.1 0-.1.1-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5152a8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 7.2l.3.3-.3-.3z",
    opacity: 0.776,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#603941"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 7l.2.2.3.3c0 .1.1.2.1.2.1 0 .1.1.1.2v.2L13 8v.2s-.1 0-.1.1V8l-.1.1h-.3c-.1-.2-.2-.4-.4-.6 0 0 0-.1.1-.1v-.1c-.1.1-.1.1-.2 0v-.2c0-.1-.1-.1-.1-.2 0 0 0 .1-.1.1.1.1.1.1 0 0v-.2c-.3-.3-.5-.6-.8-.8v-.1c.4.4.8.9 1.3 1.3 0-.2.1-.2.1-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f35c7d"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.2c0 .1-.1.2-.2.2 0-.1.1-.2.2-.2z",
    opacity: 0.706,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#454775"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3 7.4c-.1.1-.1.1 0 0-.1 0-.1 0 0 0z",
    opacity: 0.388,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3a3a54"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 7.4c0 .1 0 .1 0 0-.1.1-.1 0 0 0z",
    opacity: 0.059,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#272636"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.6l-.1.1c0-.1 0-.1.1-.1-.1-.1 0-.1 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#574fa0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 7.7v.4s0 .1-.1.1h-.2v.2H3c0-.2 0-.2-.1-.3-.1-.1-.3-.1-.4-.2 0 0 0 .1-.1.1s-.1 0-.2.1c.1.1 0 .1-.1.1 0-.1 0-.2-.1-.4 0-.1 0-.3.1-.4h.1s.1 0 .1-.1h.1v-.1c0 .1.1.1.1 0h.1c.3.1.4.2.6.3 0 .1 0 .1.2.2-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#775fe8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 7.5c.1.1.2.2.2.4 0-.1-.1-.1-.1-.2 0 0-.1-.1-.1-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b65267"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 7.7v.4c-.1-.2-.1-.3 0-.4z",
    opacity: 0.218,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3d3a50"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 7.5c0 .1 0 .2-.1.4 0 .1 0 .3.1.4-.1-.3-.1-.6 0-.8z",
    opacity: 0.424,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#413d58"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 8.1c.1 0 .1 0 .1.1l-.1-.1z",
    opacity: 0.588,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4c3135"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 8.1c.1 0 .1 0 0 0 0 .1 0 0 0 0z",
    opacity: 0.647,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#413b56"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.2l.2.2c-.1 0-.2-.1-.2-.2z",
    opacity: 0.859,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#594b7d"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 7.9v.3c0 .1 0 .1-.1.2 0-.1 0-.1.1-.2v-.3z",
    opacity: 0.388,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#533a41"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 8.5c.1 0 .1.1.2.2-.1-.1-.2-.1-.2-.2z",
    opacity: 0.553,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3c344c"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 8s0 .1 0 0l.1.1c0 .1.1.2.2.2-.1.1 0 .2.1.3 0 0 0 .1 0 0 0 .1.1.1.2.1.1.2.2.3.2.4 0 .1 0 .2.1.3.1.1.1.2.2.3 0 .1 0 .1 0 0 0 0 .1 0 .1.1 0 0-.1 0-.1.1h.1v0h.1v.1h.1-.1c0 .1.1.1.2.2 0 0 0-.1.1-.1s.1.1.2.1h-.1s-.1 0-.1.1c0 0 0 .1.1.1H5c0-.1-.1-.1-.2 0 0 .1-.1.1-.1.2h.1v.1l-.1-.1c.1 0 .1.1.1.2h.1v.1c-.5-.4-.9-.8-1.4-1.3h-.1c0-.1-.1-.1-.1-.1s-.1 0-.1-.1-.2-.3-.3-.4c-.2-.1-.4-.3-.5-.5-.1 0-.2-.1-.2-.3.1 0 .1-.1.1-.1.1 0 .1 0 .2-.1v-.1c.1.1.3.1.4.2l.2.2h.1v-.2l.2-.1c-.1.1 0 .1 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#835de1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.7s.1 0 0 0c0 .1 0 0 0 0z",
    opacity: 0.788,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#51436d"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 9c.1 0 .2.1.3.2-.1 0-.2-.1-.3-.2z",
    opacity: 0.024,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#373146"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 9.1c-.2-.1-.4-.1-.6 0 .1-.1.2-.1.3-.1.1 0 .2 0 .3.1z",
    opacity: 0.553,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#434a68"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9 9l.4.4c-.2-.1-.3-.2-.4-.4z",
    opacity: 0.824,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#524573"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 9.1s.1 0 0 0c0 .1 0 0 0 0z",
    opacity: 0.012,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2c2f40"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 9.1c0 .1-.1.1-.1.1 0-.1 0-.1.1-.1z",
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#495582"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.2z",
    opacity: 0.682,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4d5686"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 9.2c0 .1.1.1.2.1 0 .2.2.3.3.4H5c-.1-.1-.2-.2-.2-.3h-.1c-.1 0-.1 0-.1-.2-.1.1-.1.1 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#7757bf"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 9.2c.1 0 .1.1.1.1-.1 0-.1 0-.1-.1z",
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4b4063"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 9.1s0 .1 0 0c.1.1.1.2.1.2v.3c0 .1 0 .1-.1.2-.1 0-.1.1-.1.1-.1 0-.1.1-.1.1l-.2.2h-.1c0 .1-.1.1-.2.1v.1h-.1c-.1 0-.2.1-.1.2-.1 0-.1 0-.1.1-.1 0-.1 0-.1.1-.1 0-.1 0-.1.1h-.1v.1h-.2v.1h-.1v.1c-.2.2-.4.3-.7.1 0 0 0-.1-.1-.1 0-.1 0-.1-.1-.1-.1-.1-.1-.3 0-.4.1.3.1.3.1.2.1-.1.2-.1.2-.2l.1-.1c.3-.3.6-.5.9-.8v-.1c.1-.1.3-.2.4-.4 0-.1.1-.1.1-.1.1 0 .1 0 .1-.1.2-.1.4-.1.6 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5d6fed"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.3c.1.1.1.2 0 .3.1-.1 0-.2 0-.3z",
    opacity: 0.365,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3b3e54"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 9.3c-.1.2-.2.3-.4.4.1-.1.2-.3.4-.4z",
    opacity: 0.847,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4c5b8f"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 9.5c.1 0 .1.1.1.1l-.1-.1z",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#524574"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1 9.6H.7c.1 0 .1-.1.2-.1.1.1.2.1.2.1z",
    opacity: 0.435,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#403e57"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 9.6H14c.2-.1.3-.1.4 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#455b86"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1 9.6c.1 0 .1 0 .2.1-.1 0-.1-.1-.2-.1z",
    opacity: 0.412,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3e3c57"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.6c.5.5.9.9 1.4 1.3 0 0 0 .1.1.1-.6-.4-1.1-.9-1.5-1.4z",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3e3655"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.6s0 .1 0 0c-.1 0 0 0 0 0z",
    opacity: 0.812,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#47597a"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.6h.4c.1 0 .1.1.2.1v.1h-.1v.1c0 .1.1.1.1.2s-.1.2-.2.2v.1c-.1.1-.1.3-.1.4 0 .1 0 .2-.1.3v.5c0 .1 0 .1.1.2h.1v.2c.1.1.1.1.1.2v-.1c.1.1.1.1 0 .2.1.1.1.2 0 .3v.1c0 .1 0 .1.1.2 0 .1-.1.2-.1.3h-.1v.2c-.1.2-.3.4-.5.6 0 0-.1 0-.1.1 0 0 0 .1-.1.1s-.1 0-.1.1c-.1.1-.1.2-.2.2s-.1 0-.1.1c-.4.3-.8.5-1.2.6h-.2c0-.1 0-.2.1-.2h.2s.1-.1.2-.1h.1c0 .1 0 .1.1 0v-.1l.1-.1c-.1 0-.1-.1-.1-.1h-.2c0-.1-.1-.2-.1-.4h-.1c-.2.1-.3.1-.4.2 0 .1-.1.1-.1.2l-.1-.1h-.4c-.1 0-.2-.1-.3-.1 0 0 0-.1-.1-.1h.1c-.1 0-.2 0-.2-.1h.6c.2 0 .3 0 .4-.1h.1c.1 0 .2 0 .2-.1.1 0 .2 0 .2-.1.1 0 .1-.1.2-.1 0 0 .1 0 .1-.1h.1s.1 0 .1-.1c.1 0 .1 0 .1-.1.1 0 .1 0 .1-.1l.3-.3c0-.1 0-.1.1-.1 0 0 .1 0 .1-.1 0 0 .1 0 .1-.1.1 0 .1-.1.1-.1 0-.1.1-.2.1-.2l.2-.2V12c0-.2 0-.3.1-.5v-.8c0-.1 0-.2-.1-.3 0-.2 0-.3.1-.4 0 0 .1 0 .1-.1-.3-.2-.2-.2-.1-.3 0 .1 0 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4880f2"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M.8 9.6c-.1.1-.1.1 0 0-.1 0-.1 0 0 0z",
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4d4a79"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M.7 9.7c0 .1-.1.1-.1.2-.1-.1 0-.2.1-.2z",
    opacity: 0.741,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4a4677"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 9.7l.6.6-.6-.6z",
    opacity: 0.576,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f3653"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 9.7c0 .1 0 .1 0 0 0 .1 0 .1 0 0z",
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4c476e"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 9.7c0 .1 0 .1 0 0-.1.1 0 .1 0 0z",
    opacity: 0.706,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4c6391"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.7c0 .1-.1.1-.1.1l.1-.1z",
    opacity: 0.059,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#272a39"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 9.8c0 .1 0 .1 0 0 0 .1 0 0 0 0z",
    opacity: 0.376,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3e3b58"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 9.7c.1.1.2.2.2.4l-.1-.1c0 .1 0 .1-.1 0 .1-.1.1-.2 0-.3 0 .1 0 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4b6aae"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 9.8l.1.1c-.1.1-.1 0-.1-.1z",
    opacity: 0.776,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#595195"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 9.8v.1c0 .1.1.1.1 0 0 .1.1.1.1.1 0 .1 0 .1.1.2.1.3.1.5.1.8 0 .2 0 .5-.1.7 0 .1-.1.1-.1.2l-.3.9c0-.1 0-.1-.1-.2v-.1c.1-.1.1-.2 0-.3.1-.1.1-.1 0-.2v.1c0-.1 0-.2-.1-.2v-.2h-.1c0-.1-.1-.1-.1-.2 0-.2.1-.3 0-.5 0-.1.1-.2.1-.3 0-.2 0-.3.1-.4v-.1l.2-.2c0-.1-.1-.1-.1-.2v-.1c.1.1.2.1.2.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4881ed"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 9.9c0 .2-.1.3-.1.4-.1-.1 0-.2.1-.4z",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#434066"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 9.9c0 .1-.1.1-.1.1s0-.1.1-.1z",
    opacity: 0.012,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#21232e"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 9.7c-.3.4-.6.6-.9.9l.9-.9z",
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#46537f"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1 9.6c.1 0 .1.1.2.1 0 0 .1 0 .1.1 0 0 0 .1.1.1 0 .1 0 .1.1.2 0 .4-.1.8 0 1.1 0 .2.1.4.1.6 0 .1.1.2.2.3l.1.1s0 .1.1.1v.1s0 .1.1.1c0 0 0 .1.1.1 0 .1 0 .1.1.1v.1s0 .1-.1.1-.2 0-.2.1c-.2-.1-.1 0-.1 0 .1 0 .1.1.1.2H2h.1v.1c.1 0 .2 0 .2.1.1 0 .1 0 0 .1.1 0 .2 0 .2.1l.1-.1v.1c.1 0 .1.1 0 .1.1 0 .2.1.2.2-.1 0-.1.1-.2.1v-.1c0-.1-.1-.1-.1 0v.1c0 .1.1.1.1 0l.1.1s-.1 0 0 .1h.1s.1 0 0 .1h-.1v.1s-.1-.1-.2-.1h-.1s0-.1-.1-.1c0-.1-.1-.1-.1-.1 0-.1-.1-.1-.2-.2l-.3-.3c0-.1 0-.1-.1-.1v-.1c-.1 0-.1-.1-.2-.1 0 0 0-.1-.1-.1 0 0-.1 0-.1-.1s-.1-.1-.1-.1 0-.1-.1-.1c0 0 0-.1-.1-.1v-.1s0-.1-.1-.1v-.1s0-.1-.1-.1c0-.1-.1-.1-.1-.2s0-.1-.1-.1c0-.1 0-.1-.1-.2 0-.1-.1-.1-.1-.2-.1-.3-.1-.7-.2-1v-.8c.1-.1.1-.3.1-.4 0 0 .1 0 .1-.1.1 0 .1-.1.1-.2 0 0 .1 0 .1-.1.4.5.5.5.6.5z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6c65ee"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 10.1c0 .1.1.1.1.2-.1 0-.1-.1-.1-.2z",
    opacity: 0.659,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#485979"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 10.3c-.1.1-.1.2-.2.2v-.1c.1-.1.1-.1.2-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#545fb9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 10.5l.1.1c.1 0 .1.1.2.2 0 .1.1.1.1.1 0 .1 0 .2.1.2v.1c.1 0 .1 0 0 0h.1c0 .1 0 .1.1.1v.1l.1-.1c.1 0 .1.1.1.1s0 .1.1.1c.2.1.2.1.3.2 0 0 0 .1.1.1l.6.6c0 .1.1.1.1.2v.1c0 .1 0 .3-.1.4l-.1.1c-.1 0-.1 0-.1.1h-.4c0-.3 0-.3-.1-.3 0-.1-.1-.1-.2-.2l-.3-.3v-.1c-.2-.2-.4-.4-.7-.6-.1 0-.1-.1-.1-.1-.1-.1-.2-.2-.4-.3-.1-.1-.2-.1-.2-.2 0 0 0-.1-.1-.1v-.3c.1 0 .1-.1.1-.1.1 0 .1 0 .1-.1.1 0 .1-.1.2-.1.2-.1.3-.1.3 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#865adf"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 10.5c.1 0 .1 0 .1.1 0-.1-.1-.1-.1-.1z",
    opacity: 0.329,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#494059"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 10.5h-.4c.1 0 .1-.1.2-.1l.2.1z",
    opacity: 0.453,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f4a5e"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 10.5c0 .1-.1.1-.1.1 0-.1.1-.1.1-.1z",
    opacity: 0.741,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#554978"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 10.6s-.1 0 0 0c-.1 0-.1-.1 0 0z",
    opacity: 0.788,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#485a7e"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 10.5c.1 0 .2 0 .2.1-.1 0-.1 0-.1-.1 0 .1-.1.1-.1 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4e69b1"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3 10.6c0 .1-.1.1-.1.1l.1-.1z",
    opacity: 0.871,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#534577"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 10.5c-.1.1-.1.2-.2.2-.1-.1 0-.1.2-.2h-.1.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4d56a2"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 10.7c.1 0 .1.1.1.1-.1 0-.1-.1-.1-.1z",
    opacity: 0.824,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5a4977"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 10.7l.6.6-.6-.6z",
    opacity: 0.024,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3b344c"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 10.6c.1 0 .1.1.1.1-.1 0-.1 0-.1-.1z",
    opacity: 0.706,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#424f6f"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 8.4l.1.1c0 .1.1.2.2.2 0 .1 0 .1.1.1s.1.1.2.2l.3.3v.1l.1.1h.1l.2.2h.1l.6.6.4.4.6.6c0 .1 0 .1.1.2h-.1c-.1 0-.1-.1-.1-.1h-.1v.1c-.1 0-.1 0 0 .1v.1h-.1l.1.1h-.2c0 .1-.1.1-.1.1s0 .1.1.1H6c.1 0 .1.1 0 .1V12c-.1-.1-.2-.3-.4-.4h-.1c-.1 0-.1-.1-.1-.1l-.1-.1-.4-.4s0-.1-.1-.1v-.1h-.1c0-.1 0-.1-.1-.2l.1.1v-.1h-.1c0-.1.1-.1.1-.2.1-.1.1-.1.2 0H5s0-.1-.1-.1c0 0 0-.1.1-.1h.1c-.1 0-.1-.1-.2-.1 0 0 0 .1-.1.1l-.2-.2s.1 0 .1-.1h-.1v-.1h-.1v.1c-.1 0-.1-.1 0-.1h-.1s.1 0 .1-.1l-.1-.1c-.1 0-.1 0 0 0 0-.1 0-.1-.1-.2s-.1-.2-.1-.3c0-.1-.1-.2-.2-.3-.1 0-.2 0-.2-.1-.1 0-.1 0 0 0-.1-.1-.2-.2-.1-.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#845de0"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 10.8c-.1 0 0-.1 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4a539a"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 10.7c-.1.1-.1.2-.2.2 0-.1.1-.2.2-.2z",
    opacity: 0.635,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3c4460"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M.3 10.4v0z",
    opacity: 0.153,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#25242e"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 10.8c.2.1.3.3.5.5 0 0-.1 0-.1.1v-.1c-.1 0-.1 0-.1-.1h-.1c.1.1.1.1 0 0v-.1c-.2-.1-.2-.2-.2-.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#7c56c3"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 10.9s0 .1 0 0c-.1 0 0-.1 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#49539a"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.9c0 .1 0 .1 0 0-.1.1-.1 0 0 0z",
    opacity: 0.682,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4c5a8b"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 10.3c0 .1.1.2.1.3v.8c0-.5-.1-.8-.1-1.1z",
    opacity: 0.253,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#373f4d"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 11.1l.1.1c-.1 0-.1-.1-.1-.1z",
    opacity: 0.294,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f3951"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 11l-.2.2v-.1c.1 0 .1 0 .2-.1-.1 0-.1 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#495298"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 10.5c0 .1 0 .1.1.1l.1.1c0 .1 0 .1.1.1.1.1.1.2 0 .4-.1 0-.1 0-.1.1-.1.1-.2.2-.2.3h-.1v.1l-.6.6s-.1 0-.1.1l-.2.2v-.1l-.2.2v.1h-.1v0c-.1 0-.1.1-.2.1 0 0 0 .1.1.1h-.1v.1c-.2.2-.4.3-.7.2 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1-.1-.1-.2-.3-.1-.5 0 0 .1 0 .1-.1.2-.1.3-.3.5-.5.1-.1.1-.2.2-.2s.2-.1.3-.2v-.1s0-.1.1-.1c.4-.3.7-.6 1-1 0 0 .1 0 .1-.1 0 .2.1.2.2.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4d7af2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10v.2c-.1.7-.1 1.3.2 1.9-.1-.1-.1-.2-.2-.3-.1-.2-.1-.4-.1-.6 0-.4 0-.8.1-1.2z",
    opacity: 0.294,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3a384f"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11.4s0 .1 0 0c.3.2.4.3.6.5V12.2c.1 0 .1.1 0 .1 0 .1 0 .2-.1.3-.1 0-.2.1-.3.1v.1h-.1v.1l-.5-.5-.3-.3c.1 0 .1-.1 0-.1h.2l-.1-.1.1-.1h.2s0-.1-.1-.1h.1v-.1c-.1-.1-.1-.1 0-.1v-.1h.1c0 .1 0 .1.1.1 0-.1 0-.1.1-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#7f5fe0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 11.3l.2.2h-.1c-.1-.1-.1-.2-.1-.2z",
    opacity: 0.765,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#50446c"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.1c-.1.2-.2.3-.4.4v-.1h.1c0-.1.1-.2.3-.3-.1 0-.1 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#455fac"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.2c-.1.1-.1.2-.2.2v-.1h.1v-.1h.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4b54a1"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 10.6c-.3.4-.7.7-1 1 .3-.3.6-.7 1-1z",
    opacity: 0.824,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#455984"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 11.3c0 .1.1.1 0 0 0 .1 0 .1 0 0z",
    opacity: 0.012,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#312c40"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.4c.1.1.3.2.4.3-.2 0-.3-.1-.4-.3z",
    opacity: 0.765,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#413757"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 11.4c.1 0 .1 0 0 0 .1.1 0 0 0 0z",
    opacity: 0.529,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#504266"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 11.4c.1 0 .1 0 0 0 .1.1.1 0 0 0z",
    opacity: 0.506,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#42466b"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 11.5c.1 0 .1.1.2.2l-.2-.2z",
    opacity: 0.012,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#322c3d"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.5c.1 0 .1 0 0 0 .1 0 0 0 0 0z",
    opacity: 0.671,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4f5489"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 11.5h.1l.4.4v.1s-.1 0-.1-.1l-.1-.1c0-.1-.1-.1-.1-.1l-.2-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#7759c9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 11.7z",
    opacity: 0.012,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#312b3a"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 11.7c.1 0 .1 0 0 0 .3.2.4.4.6.6l-.6-.6z",
    opacity: 0.024,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#352e42"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M.3 11.2c0 .3.1.7.2 1-.1-.4-.2-.7-.2-1z",
    opacity: 0.176,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3c3c57"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 11.8c.1 0 .1 0 .1.1-.1 0-.1 0-.1-.1z",
    opacity: 0.565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#383249"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9 11.9c.2.2.5.4.7.6-.2-.2-.5-.4-.7-.6z",
    opacity: 0.871,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#483c65"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 11.7c-.1.2-.2.3-.3.3l.3-.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4b6dc3"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 11.8c0 .1 0 .1-.1.2 0 0 0-.1.1-.2z",
    opacity: 0.706,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#435371"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 11.9c0 .1.1.1 0 0 0 .1 0 .1 0 0z",
    opacity: 0.024,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#322d42"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 11.7v.3l-.2.2c0-.1.1-.3.2-.5z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4971c3"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 11.9c.4.4.9.8 1.3 1.2l-.3-.3c-.4-.2-.7-.5-1-.9 0 .1 0 .1 0 0z",
    opacity: 0.541,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#343145"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.1c0 .1 0 .1 0 0-.1.1-.1.1 0 0z",
    opacity: 0.012,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2c3342"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 12.2s.1 0 0 0c0 .1 0 0 0 0z",
    opacity: 0.424,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f3e59"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 12.3c.1 0 .1.1.1.2 0-.1 0-.1-.1-.2z",
    opacity: 0.894,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5a4879"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 12.2c-.1.2-.3.3-.5.5.1-.2.3-.4.5-.5z",
    opacity: 0.776,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#405071"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 12.3s.1.1.1.2c0-.1-.1-.1-.1-.2z",
    opacity: 0.541,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#48466b"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 12.4s.1 0 0 0z",
    opacity: 0.482,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#41415c"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 12.4l.5.5c0 .1.1.1.1.2h-.1c-.1-.2-.3-.5-.5-.7z",
    opacity: 0.012,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#332f47"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 12.4l-.6.6s0-.1-.1-.1c0-.1.1-.1.2-.1v0h.1v-.1c.3-.2.3-.3.4-.3 0-.1 0 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4e6ecf"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.4c0 .1 0 .1 0 0 0 .1 0 .1 0 0z",
    opacity: 0.494,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#403e59"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M.6 12.5l.1.1c-.1 0-.1-.1-.1-.1z",
    opacity: 0.365,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#393951"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5c.1 0 .1.1.1.1s-.1 0-.1-.1z",
    opacity: 0.729,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#434265"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 12.6l.3.3-.3-.3z",
    opacity: 0.612,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3a324f"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 12.5c0 .1 0 .1-.1.1l.1-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#456096"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 12l.9.9h-.2v.1s-.1.1-.1.2l-.1.1c-.1.1-.2.1-.3.1 0 0 0 .1-.1.1s-.1 0-.1.1l-.6-.6c.1 0 0 0 0-.1v-.1h.1v-.1c.1 0 .2-.1.3-.1.1-.1.1-.2.1-.3.2 0 .2-.1 0-.1.1-.1.1-.1.1-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#7664e4"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 12.7c.1 0 .1.1.1.1l-.1-.1z",
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#414064"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 12.5c.1.1.1.2 0 .3 0 0 0 .1-.1.1.1-.1.1-.2.1-.4z",
    opacity: 0.694,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4a4060"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 12.7z",
    opacity: 0.471,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#404d68"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 12.7z",
    opacity: 0.565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#41526e"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 12.7c.1.1.1.1 0 0l.4.4c0 .1.1.1.1.1s0 .1.1.1c0 .1.1.1.1.1h.1c.1.1.3.2.4.2 0 0 .1.1.2.1s.1.1.2.1l.1.1s0 .1.1.1.2.1.2.1c-.1 0-.2.1-.3.2 0 .1 0 .1-.1.2 0 .1 0 .3-.1.3v.1h.1c.1.1 0 .1 0 .1-.1 0-.2 0-.3-.1-.1-.1-.2-.1-.3-.1 0-.1-.1-.1-.2-.1 0 0-.1 0-.1-.1 0 0 0-.1-.1-.1 0 0-.1 0-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1.1 0 .1.1.2.1v-.1h.1v-.1h-.1V14l-.1-.1c0 .1-.1.1-.1 0v-.1c0-.1.1-.1.1 0v.1c0-.1.1-.1.2-.1l-.2-.2c.1 0 .1-.1 0-.1.1 0 .1-.1 0-.1l-.1.1c-.1 0-.1-.1-.2-.1.1 0 .1-.1 0-.1 0-.1 0-.2-.2-.1v-.1h-.1.1c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1.1 0 .2 0 .2-.1.2.1.2.1.2 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6767f0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 12.8l.4.4-.4-.4z",
    opacity: 0.824,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#46446e"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 12.7c0 .1 0 .1 0 0-.1.1-.1.1 0 0z",
    opacity: 0.624,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#455674"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M.8 12.8c0 .1 0 0 0 0z",
    opacity: 0.259,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#343448"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 12.9c.1 0 .1.1.2.2-.1-.1-.1-.2-.2-.2z",
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#453961"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M.8 13c.1 0 .1 0 0 0 .1 0 0 0 0 0z",
    opacity: 0.294,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#38374f"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 13c0 .1-.1.1-.1.1V13h.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3d4f89"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 13c.1 0 .1 0 .1.1 0 0-.1 0-.1-.1z",
    opacity: 0.741,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#58477b"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 13l-.1.1.1-.1z",
    opacity: 0.306,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#52476b"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 13.1h.4c-.1 0-.1 0-.2.1-.1-.1-.2-.1-.2-.1z",
    opacity: 0.741,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#52446e"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13l-.3.3.3-.3z",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#475e8a"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M.9 13.1c.1 0 .1 0 0 0 .1.1 0 0 0 0z",
    opacity: 0.176,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2d2c3c"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 13.1c.1 0 .1.1.1.1-.1 0-.1 0-.1-.1z",
    opacity: 0.671,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#45446f"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 13.2c0 .1 0 .1-.1.2 0-.1 0-.2.1-.2-.1 0-.1 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4662a1"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.2s.1 0 0 0c0 .1 0 0 0 0z",
    opacity: 0.012,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262634"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 13.2s.1 0 0 0c0 .1 0 .1 0 0z",
    opacity: 0.835,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#485684"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 13.3c.1-.1.1 0 0 0z",
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2b2c3c"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 12.9l.3.3c.1 0 .1.1.1.1l.1.1c0 .1.1.1.1.1 0 .1 0 .2.1.2 0 .1-.1.1-.1.2h-.2v.1c-.1.1-.2.1-.2.2v.1c-.1 0-.1 0-.2-.1v.1l-.1-.1s-.1 0-.1-.1l-.6-.6c0-.1 0-.1.1-.1s.1 0 .1-.1c.1 0 .2-.1.3-.1l.1-.1c0-.1 0-.2.1-.3-.1 0-.1 0 0-.1 0 .2 0 .2.1.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#666bed"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 13.3c.1 0 .1 0 .1.1l-.1-.1c.1.1.1 0 0 0z",
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2e3042"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 13.3z",
    opacity: 0.306,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#373f52"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 13.3c0 .1-.1.1-.1.1 0-.1 0-.1.1-.1z",
    opacity: 0.671,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#42526f"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1 13.3c.1 0 .1.1.1.1-.1 0-.1-.1-.1-.1z",
    opacity: 0.565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3d3b5c"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 13.3c.1 0 .1 0 .1.1 0 0-.1 0-.1-.1z",
    opacity: 0.835,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#44446e"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 13.4c0 .1-.1.1-.1.1 0-.1 0-.1.1-.1z",
    opacity: 0.694,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#435673"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.4c.2.1.3.2.4.2-.1 0-.3-.1-.4-.2z",
    opacity: 0.835,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3d3d5e"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.5c-.1 0-.1 0 0 0-.1 0-.1 0 0 0z",
    opacity: 0.847,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4a6289"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 13.5c.1 0 .1 0 0 0 .1.1 0 0 0 0z",
    opacity: 0.047,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2c2b3e"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 13.4c.1 0 .2.1.3.2 0 .1.1.1.1.1h.1l.1.1.1.1v.1c.1.1.1.1.1.2v.1h-.2s-.1 0-.1.1.1.1.1 0v.1c.1 0 .1 0 0 .1-.2.1-.3.2-.4.3h-.4l-.1-.1c0-.1-.1-.1-.1-.1v-.1c.1.1.1.1.2.1v-.1c.1-.1.2-.1.2-.2v-.1H9c0-.1 0-.1.1-.2-.1-.4-.2-.5-.1-.6-.1 0-.2 0-.2-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5872f0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 13.6c.1 0 .1 0 .1.1 0-.1-.1-.1-.1-.1z",
    opacity: 0.871,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#434973"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 13.6c-.1 0 0-.1 0 0z",
    opacity: 0.741,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#455472"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3 13.6c.1 0 .1.1.2.1v.1l-.2-.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5c59b5"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.6l.6.6H8c-.2-.2-.3-.4-.5-.6z",
    opacity: 0.012,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#303147"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 13.7c.1 0 .1 0 .2.1-.1-.1-.1-.1-.2-.1z",
    opacity: 0.459,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#41415d"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 13.7s.1 0 .1.1l-.1-.1z",
    opacity: 0.341,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313445"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 13.7c.1 0 .1 0 .2.1-.1 0-.2 0-.2-.1z",
    opacity: 0.012,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2f2f42"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 13.7s.1 0 .1.1c0 0-.1 0-.1-.1z",
    opacity: 0.424,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#35394c"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7c-.1.1-.1.1-.2.1.1-.1.2-.1.2-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4b65a0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 13.8c.1 0 .1 0 0 0 0 .1 0 0 0 0z",
    opacity: 0.506,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43426b"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 13.8c-.1.1-.1.1-.2.1.1-.1.1-.1.2-.1z",
    opacity: 0.976,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#506dab"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 13.9l.3.3-.3-.3z",
    opacity: 0.812,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#49487a"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 13.8c.6.1 1.1.1 1.7 0 .1 0 .2 0 .3.1h-.3c-.5.1-1 .1-1.5 0-.1 0-.1-.1-.2-.1z",
    opacity: 0.482,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#44486a"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.9c.5.1 1 .1 1.5 0h.3l.1.1c.1-.1.1 0 .1 0 0 .1.1.1.1.1v.4s-.1 0-.1-.1v.1h-.1v.2c-.1.3-.3.3-.5.4-.5.1-1 .1-1.6 0h-.2c.1 0 .1 0 .2-.1h-.1c.1 0 .1-.1 0-.1.1-.1.2-.2.1-.3.2-.2.2-.2.2-.3.1-.1.1-.2.3-.2-.1-.1-.2-.1-.3-.1v-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5f6ef0"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 13.9c.1 0 .1 0 .1.1 0-.1-.1-.1-.1-.1z",
    opacity: 0.341,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3e425c"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.8c.1.1.3.1.4.1.1.1.3.1.5.1.1 0 .1.1.2.1h-.1l.1.1c0 .1-.1.2-.2.2v.1c-.1 0-.1.1-.2.1 0 0 .1.1.1.2 0-.1.1-.1.1 0v.1c.1.1.2.1.3.2.1 0 .2 0 .2.1h-.4c-.2 0-.5 0-.7-.1-.1 0-.1-.1-.2-.1 0-.1-.1-.1-.2-.1s-.1 0-.2-.1c0 .2 0 .2-.1.2 0 0-.1 0-.1-.1 0 0 0-.1-.1-.1h-.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1h.4c.1-.1.3-.2.4-.3v-.1-.1h-.1s.1 0 .1-.1h.2v-.1c.1.2 0 .1 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4f78f1"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.9c.3.1.6.1.9.1h-.5c-.1 0-.3 0-.4-.1z",
    opacity: 0.788,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#363e52"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.9c-.2.1-.3.1-.5.1.2 0 .3-.1.5-.1z",
    opacity: 0.729,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#42526e"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 13.9c0 .1 0 .1 0 0-.1.1 0 .1 0 0z",
    opacity: 0.024,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#272e3b"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14c.1 0 .1.1.1.1L6 14z",
    opacity: 0.894,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4b5283"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 15.1c-.1 0-.2.1-.3.1H11c-.1 0-.1-.1-.2-.1-.1-.1-.2-.1-.3-.2v-.1h-.1c0-.1-.1-.1-.1-.2.1 0 .1-.1.2-.1v-.1l.2-.2c.1.1.2.1.3.1h.4s.1 0 .1.1c.1 0 .1-.1.1-.2.1 0 .3-.1.4-.2 0 0 .1.1.1 0 0 .1.1.2.1.4h.2c0 .1.1.1.1.1l-.1.1s.1 0 0 .1h-.1-.1c-.1.1-.1.1-.2.1h-.2v.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4b7ef5"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 14.1c0 .1-.1.1-.1.1 0-.1 0-.1.1-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3a4e85"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 14.2c.1 0 .1.1.2.2l-.2-.2z",
    opacity: 0.565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3e3c61"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 14.3c.1 0 .1 0 .1.1-.1 0-.1 0-.1-.1z",
    opacity: 0.729,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#423f64"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 14.3c.1 0 .1 0 .1.1-.1 0-.1 0-.1-.1z",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#42486f"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 14.4c0 .1-.1.1-.1.1 0-.1.1-.1.1-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#425996"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 14.2c.1.1.1.3 0 .4v-.4z",
    opacity: 0.741,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#464c76"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 14.4s.1 0 0 0c0 .1 0 0 0 0z",
    opacity: 0.529,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#424163"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 14.4c.1 0 .1.1.1.1s-.1 0-.1-.1z",
    opacity: 0.859,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4a5182"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3 14.5c.1 0 .1 0 0 0z",
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#494673"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 14.5s.1 0 0 0c0 .1 0 .1 0 0z",
    opacity: 0.553,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#47456f"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.5s.1 0 .1.1c-.1 0-.1 0-.1-.1z",
    opacity: 0.812,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#48527d"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.6z",
    opacity: 0.424,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3e3d5a"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 14.6c0 .1-.1.2-.2.2v-.2c0 .1.1.1.2 0-.1 0-.1 0 0 0-.1 0-.1 0 0 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5460bd"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 14.6s.1 0 0 0c0 .1 0 .1 0 0z",
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#465076"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 14.7s.1 0 0 0c0 .1 0 0 0 0z",
    opacity: 0.329,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#39374f"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 14.7s.1 0 0 0c0 .1 0 0 0 0z",
    opacity: 0.541,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#444c6e"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 14.8c0-.1 0 0 0 0z",
    opacity: 0.424,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3d445d"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9 14.8c.1 0 .1 0 .2.1-.1 0-.2-.1-.2-.1z",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#454272"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.9c.1 0 .2 0 .3.1-.1 0-.2-.1-.3-.1z",
    opacity: 0.776,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#444470"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 14.8c.1 0 .1.1 0 0 .1.1 0 .1 0 0z",
    opacity: 0.447,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f4760"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 15c.1 0 .1 0 .1.1 0-.1 0-.1-.1-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#465388"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 15c.1 0 .2 0 .3.1-.1-.1-.2-.1-.3-.1z",
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#44456b"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 15.1c.1 0 .1 0 .2.1-.1-.1-.1-.1-.2-.1z",
    opacity: 0.941,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4a588a"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 15.1c-.3.1-.6.1-.9.1-.2 0-.4 0-.7-.1h1.6z",
    opacity: 0.329,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#353648"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 15.1h.2c-.2.1-.3.1-.5.1.1 0 .2-.1.3-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4760a0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 15.1c.1 0 .1 0 .2.1-.1 0-.1 0-.2-.1z",
    opacity: 0.612,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#424c6b"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.2c-.2.1-.5.1-.7.1h-.2.4c.1 0 .3-.1.5-.1z",
    opacity: 0.059,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2b313f"
  })));
}

export default SvgLogo16;